// import Auth from "./auth.js";
const API_BASE = process?.env?.VUE_APP_API_BASE_URL ?? '/api';

export default {
  async getData() {
    // const userId = Auth.getUserID();
    // if (!userId) {
    //   console.error("User ID not found in cookies");
    //   return Promise.reject("No user ID");
    // }
    // return fetch(`${API_BASE}/get-user?id=${userId}`, {
    //   credentials: "include"
    // })
    //   .then(response => {
    //     if (!response.ok) {
    //       throw new Error(`Network response was not ok: ${response.status}`);
    //     }
    //     return response.json();
    //   });
    const res = await fetch(`${API_BASE}/get-logged-in-user`, {
      credentials: 'include',
      headers: { 'Accept': 'application/json' }
    });
    if (!res.ok) {
      // 401 here means no cookie (not logged in)
      throw new Error(`HTTP ${res.status}`);
    }
    return res.json();
  },

  async updateProfile(userData) {
    // return fetch(`${API_BASE}/edit-user`, {
    //   method: "POST",
    //   headers: {
    //     "Content-Type": "application/json"
    //   },
    //   credentials: "include",
    //   body: JSON.stringify(userData)
    // }).then(response => {
    //   if (!response.ok) {
    //     throw new Error("Failed to update profile");
    //   }
    //   return response.json();
    // });

      const res = await fetch(`${API_BASE}/edit-user`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(userData)
      });
      if (!res.ok) throw new Error('Failed to update profile');
      return res.json();
    }
};
